import { Flex, Spin } from 'antd'

import { useStyles } from './styles'

export const LoadingScreen = () => {
  const { styles } = useStyles()

  return (
    <Flex justify="center" align="center" className={styles.loader}>
      <Spin />
    </Flex>
  )
}
